
const initialState = {
  redirectTo: null, // e.g. "/profile"
};

const NAVIGATE_TO = "NAVIGATE_TO";
const CLEAR_NAVIGATION = "CLEAR_NAVIGATION";

export const navigateTo = (path) => ({
  type: NAVIGATE_TO,
  payload: path,
});

export const clearNavigation = () => ({
  type: CLEAR_NAVIGATION,
});


const navigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NAVIGATE_TO:
      return {
        ...state,
        redirectTo: action.payload,
      };

    case CLEAR_NAVIGATION:
      return {
        ...state,
        redirectTo: null,
      };

    default:
      return state;
  }
};

export default navigationReducer;
